import moment from 'moment-timezone';
import { store } from '../index';
import { showNotification } from '../actions/notification';
import axios from 'axios';
import { userData, usersData } from '../actions/auth';

const STORAGE_TYPE = 'local';

export const deleteLocalData = (key) => {
  if (STORAGE_TYPE === 'local') {
    window.localStorage.removeItem(key);
  } else if (STORAGE_TYPE === 'session') {
    window.sessionStorage.removeItem(key);
  }
};
export const toLocalTimeSupport = (dateTime, format) => {
  if (!dateTime) {
    return dateTime;
  }
  window.console.log(dateTime);
  let dt = moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
  window.console.log(dt);
  return moment(moment.utc(dt).toDate()).format(format || "YYYY-MM-DDThh:mma");
}
export const toLocalTime = (time, format) => {
  window.console.log(time);
  if (!time) {
    return time;
  }
  const [hours, mins] = time.split(':');
  window.console.log(time, hours, mins, moment().set({ hour: hours, minute: mins }));
  return toLocalTimeSupport(moment().set({ hour: hours, minute: mins }), format);
}
export const localCopy = obj => {
  return JSON.parse(JSON.stringify(obj));
}

export const setLocalData = (key, value) => {
  window.console.log(key, value);
  if (typeof value !== null && typeof value === 'object') {
    value = JSON.stringify(value)
  }
  if (STORAGE_TYPE === 'local') {
    window.localStorage.setItem(key, value);
  } else if (STORAGE_TYPE === 'session') {
    window.sessionStorage.setItem(key, value);
  }
};

export const notify = (message, type, autoClose = true, time = undefined) => {
  store.dispatch(showNotification('NOTIFICATION', {
    message: message,
    type: type,
    autoClose,
    time
  }));
};

export const setRefreshToken = (token) => {
  setLocalData('refreshToken', token);
};

export const getLocalData = (key) => {
  if (STORAGE_TYPE === 'local') {
    let returnData = window.localStorage.getItem(key) || null;
    try {
      returnData = JSON.parse(returnData);
    } catch (e) {
      return returnData;
    }
    return returnData;
  } else if (STORAGE_TYPE === 'session') {
    let returnData = window.sessionStorage.getItem(key) || null;
    try {
      returnData = JSON.parse(returnData);
    } catch (e) {
      return returnData;
    }
    return returnData;
  }
};

export const isLoggedIn = () => {
  return store.getState().user && Object.keys(store.getState().user).length ? true : false;
};

export const validHostNamesSantry = {
  
};

export const validHostNames = {

};


export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  /*eslint-disable */
  name = name.replace(/[\[\]]/g, "\\$&");
  /*eslint-enable */
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const formattedDate = date => {
  const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  if (!date) {
    return false;
  }
  if (isNaN(Date.parse(date))) {
    return false;
  }
  let d = new Date(date);
  return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
};

export const isMobileDevice = () => {
  let check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const scrollTop = (time) => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};


export const pixelEvent = (eventName, data) => {
  if (data && data.student_name) {
    delete data.student_name;
  }
  if (data && data.first_name) {//Child first name
    delete data.first_name;
  }
  if (data && data.last_name) {//Child last name
    delete data.last_name;
  }
  if (data && data.email) {
    data.em = data.email.toLowerCase();;
    delete data.email;
  }
  if (data && data.phone) {
    data.ph = data.phone;
    delete data.phone;
  }

  if (data && data.news_letter) {
    delete data.news_letter;
  }
  if (data && data.has_tnc_agreed) {
    delete data.has_tnc_agreed;
  }
  if (data && data.parent_name) {
    delete data.parent_name;
  }

  if (data && data.message) {
    delete data.message;
  }

  if (data && data.tags) {
    delete data.tags;
  }

  if (data && data.dataCurse) {
    delete data.dataCurse;
  }

  if (data && data.source) {
    delete data.source;
  }



  console.log("data print", data, window.location.hostname, window.fbq, validHostNames[window.location.hostname])
  if (validHostNames[window.location.hostname] && window.fbq) {
    window.fbq('track', eventName, data || {});
  }
};

export const taboolaPixel = (eventName) => {
  console.log("eventNameeventName", eventName);
  if (validHostNames[window.location.hostname] && window._tfa) {
    window._tfa.push({ notify: 'event', name: eventName, id: 1411711 });
  }

}

export const proformics = () => {
  if (validHostNames[window.location.hostname]) {
    var a = document.createElement("iframe");
    a.setAttribute("src", "");
    a.style.display = 'none';
     document.body.appendChild(a)
  }
}

export const googleEvent = (data, to) => {
  window.console.log('googleEvent', window.ga);
  if (validHostNames[window.location.hostname] && window.ga) {
    window.ga('send', data);
  }
};


export const disableScroll = () => {
  var _overlay = document.getElementsByClassName('datepicker-modal')[0];

  window.console.log(_overlay);
  if (!_overlay) {
    return;
  }

  var _clientY = null; // remember Y position on touch start

  _overlay.addEventListener('touchstart', function (event) {

    if (event.targetTouches.length === 1) {

      _clientY = event.targetTouches[0].clientY;

    }

  }, false);

  _overlay.addEventListener('touchmove', function (event) {

    if (event.targetTouches.length === 1) {

      disableRubberBand(event);

    }

  }, false);

  function disableRubberBand(event) {

    var clientY = event.targetTouches[0].clientY - _clientY;

    if (_overlay.scrollTop === 0 && clientY > 0) {
      event.preventDefault();

    }

    if (isOverlayTotallyScrolled() && clientY < 0) {
      event.preventDefault();

    }

  }

  function isOverlayTotallyScrolled() {
    return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
  }
};

export const formattedTime = date => moment(date).format('HH:mm');

export const getUrlparamsAsObject = () => {
  let params = {};
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  if (!query) {
    return {}
  }
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (params[pair[0]] && (params[pair[0]].constructor !== Array)) {
      params[pair[0]] = [params[pair[0]]];
      params[pair[0]].push(decodeURIComponent(pair[1]));
    } else if (params[pair[0]] && params[pair[0]].constructor === Array) {
      params[pair[0]].push(decodeURIComponent(pair[1]));
    } else {
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
  }
  Object.keys(params).forEach(key => {
    if (!key) {
      delete params[key];
    }
    if (!params[key]) {
      delete params[key];
    }
  })
  window.console.log(params);
  return params;
};

export const getParametersBySubstring = (name, url) => {
  if (!url) url = window.location.href;
  let parts = window.location.search.slice(1).split('&');
  let result = [];
  parts.forEach(pair => {
    pair = pair.split('=');
    result.push(decodeURIComponent(pair[1]));
  });
  return result.length ? result.filter(r => r !== '') : null;
};

export const errorHandler = (error, notification = false) => {
  window.console.log('Error Handler => ', error);

  let errorObj = {};
  if (!error) {
    errorObj = {
      error: 'Something went wrong'
    }
  }
  if (error && error.status === 500) {
    errorObj = {
      error: `Something went wrong - ${error.status} status returned`
    }
  }
  if (error && error.data && error.data.errors && error.data.errors.constructor === Object) {
    window.console.log(Object.keys(error.data.errors));
    Object.keys(error.data.errors).forEach(key => {
      window.console.log(error.data.errors[key]);
      if (Array.isArray(error.data.errors[key])) {
        error.data.errors[key].forEach((data) => {
          window.console.log(data);
          errorObj[key] = data;
        });
      } else if (error.data.errors[key].constructor === Object) {
        window.console.log('Object', error.data.errors[key]);
        Object.keys(error.data.errors[key]).forEach(k => {
          window.console.log(error.data.errors[key][k]);
          errorObj[k] = error.data.errors[key][k];
        });
      }
    });
  } else if (error && error.data && error.data.response && error.data.response.constructor === Object) {
    window.console.log(error.data.response);
    Object.keys(error.data.response).forEach(key => {
      window.console.log(error.data.response[key]);
      Object.keys(error.data.response[key]).forEach(k => {
        window.console.log(error.data.response[key][k]);
        errorObj[key] = error.data.response[key][k];
      });
    });
  } else if (error && error.data && !error.data.errors && error.data.constructor === Object) {
    window.console.log(error.data);
    Object.keys(error.data).forEach(key => {
      window.console.log(error.data[key]);
      if (typeof error.data[key] === 'string') {
        errorObj[key] = error.data[key];
      }
      if (error.data[key] && Array.isArray(error.data[key])) {
        error.data[key].forEach((data) => {
          window.console.log(data);
          errorObj[key] = data;
        });
      } else if (error.data[key] && error.data[key].constructor === Object) {
        window.console.log('Object', error.data[key]);
        Object.keys(error.data[key]).forEach(k => {
          window.console.log(error.data[key][k]);
          errorObj[k] = error.data[key][k];
        });
      }
    });
  }
  if (error && error.data && error.data.detail) {
    errorObj = {
      ...errorObj,
      message: error.data.detail
    };
  }
  if (notification) {
    Object.keys(errorObj).forEach((key, index) => {
      ((i) => {
        setTimeout(() => {
          notify(`${errorObj[key]}`, 'error');

        }, 1000 + (2000 * i));
      })(index);
    })
  }
  window.console.log(errorObj);
  return errorObj;
};

export const toUtc = (dateTime, format) => {
  const tzone = moment.tz.guess(true);
  return moment.utc(moment.tz(dateTime, tzone)).format(format || "YYYY-MM-DDTHH:mm:ss")
}

export const toUtcAmPm = (dateTime, format) => {
  const tzone = moment.tz.guess(true);
  return moment.utc(moment.tz(dateTime, tzone)).format(format || "YYYY-MM-DDThh:mma")
}

export const setAccessToken = (token) => {
  setLocalData('accessToken', token);
}

export const setAxiosHeaders = () => {
  (function () {
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.withCredentials = true;
    axios.defaults.crossDomain = true;
    if (getAccessToken()) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + getAccessToken();
    }
  })();
}

export const removeAxiosHeaders = () => {
  delete axios.defaults.headers.common['Authorization'];
}

export const setUserData = user => {
  console.log("in setuser", user)
  setLocalData('user', user);
  store.dispatch(userData(user));
}

export const setUsersData = users => {
  setLocalData('users', users);
  store.dispatch(usersData(users));
}

export const getAccessToken = () => {
  return getLocalData('accessToken') || null;
}

export const validatePhoneNumberIndia = phone => {
  if (!phone) return false;
  return phone.match(/\d/g).length === 10;
}

export const validatePhoneNumber = phone => {
  window.console.log(phone.length);
  if (!phone) {
    return false;
  }
  if (phone.length > 7 && phone.length <= 12) {
    return true;
  }
  return false;
};

export const getRefreshToken = () => {
  return getLocalData('refreshToken') || null;
};

export const getElementY = (query, offset) => {
  if (!query) {
    return;
  }
  return window.pageYOffset + query.getBoundingClientRect().top - (offset || 0)
};

export const doScrolling = (element, duration, offset) => {
  let startingY = window.pageYOffset
  let elementY = getElementY(element, offset)
  // If element is close to page's bottom then window will scroll only to some position above the element.
  let targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
  let diff = targetY - startingY
  // Easing function: easeInOutCubic
  // From: https://gist.github.com/gre/1650294
  let easing = function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1 }
  let start

  if (!diff) return

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    // Elapsed miliseconds since start of scrolling.
    let time = timestamp - start
    // Get percent of completion in range [0, 1].
    let percent = Math.min(time / duration, 1)
    // Apply the easing.
    // It can cause bad-looking slow frames in browser performance tool, so be careful.
    percent = easing(percent)

    window.scrollTo(0, startingY + diff * percent)

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
};

export const serializeObjToUrlParams = obj => {
  if (typeof obj !== 'object' || !obj) {
    return '';
  }
  let str = '';
  for (let key in obj) {
    if (str != '') {
      str += '&';
    }
    str += key + '=' + encodeURIComponent(obj[key]);
  }
  return str;
}

export const isOnlyAlphabets = (str) => {
  let regex = /^[a-zA-Z ]+$/;

  if (regex.test(str)) {
    return true;
  }
  return false;
}

export const snakeToTitleCase = str => {
  if (!str) {
    return null;
  }
  return str.split('_').map(item => item.charAt(0).toUpperCase() + item.substring(1)).join(' ');
};

export const unlinkify = (html) => {
  let regex = /<a[^>]*>([^<]+)<\/a>/g;
  let link;

  while ((link = regex.exec(html)) !== null) {
    html = html.replace(link[0], link[1]);
  }
  return html;
}

export const randomIntFromInterval = (min, max) => { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min);
}